import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { twilioNumbersApi } from '@/lib/api/twilio-numbers.api';

import type { TwilioAssignInboundNumberDto, TwilioUpdateRegionDto } from '@repo/shared-types';

const TWILIO_NUMBERS_QUERY_KEY = ['twilio-numbers'];

export function useTwilioNumbers() {
  return useQuery({
    queryKey: TWILIO_NUMBERS_QUERY_KEY,
    queryFn: () => twilioNumbersApi.list(),
  });
}

export function useSyncTwilioNumbers() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => twilioNumbersApi.sync(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: TWILIO_NUMBERS_QUERY_KEY });
    },
  });
}

export function useAssignInboundTwilioNumber() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      numberId,
      payload,
    }: {
      numberId: string;
      payload: TwilioAssignInboundNumberDto;
    }) => twilioNumbersApi.assignInbound(numberId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: TWILIO_NUMBERS_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: ['configurations'] });
    },
  });
}

export function useUpdateTwilioNumberRegion() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ numberId, payload }: { numberId: string; payload: TwilioUpdateRegionDto }) =>
      twilioNumbersApi.updateRegion(numberId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: TWILIO_NUMBERS_QUERY_KEY });
    },
  });
}
